import { NavLink, useNavigate } from 'react-router-dom';
import { selectConfirmModal, setConfirmPath, setShowConfirmLeave } from '@/features/confirmModal/confirmModalSlice';
import { useAppDispatch, useAppSelector } from '@/app/hooks';

import ContextModal from '@/modal/contextModal';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import clsx from 'clsx';
import styles from './styles.module.scss';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFeatureFlags } from '@/hooks/useFeatureFlag';

interface Props {
  title: string;
}

export const DropdownNavItem: React.FC<Props> = ({ title }) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isUserInForm, editedForm } = useAppSelector(selectConfirmModal);
  const { isCardFeature } = useFeatureFlags();
  const { isDepositsFeature } = useFeatureFlags();
  const { isExchangesFeature } = useFeatureFlags();
  const { isLoansFeature } = useFeatureFlags();
  const { isSavingFeature } = useFeatureFlags();
  const { isStatementsFeature } = useFeatureFlags();
  const { isCheckbookFeature } = useFeatureFlags();
  // const { currentUser: { isSubUser, isMain } } = useAppSelector(selectUsers);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const toogleModal = () => setIsModalOpen(!isModalOpen);

  const handleClick = (event: React.MouseEvent, href: string) => {
    event.preventDefault();
    if (isUserInForm && editedForm) {
      dispatch(setConfirmPath(href));
      dispatch(setShowConfirmLeave(true));
    } else {
      navigate(href);
    }
    toogleModal();
  };

  const customLink = (href: string, label: string, id: string) => {
    return (
      <NavLink
        to={href}
        onClick={event => handleClick(event, href)}
        id={`${id}Nav`}
        className={({ isActive }) => [styles.item, 'subtitle3', isActive && styles.item_active].join(' ')}
      >
        {label}
      </NavLink>
    );
  };

  return (
    <div className={styles.block}>
      <button id={`${title}Nav`} onClick={toogleModal} className={clsx(styles.navItem, isModalOpen && styles.navItem_active)}>
        <p className='subtitle3'>{t(`nav.${title}`)}</p>
        {isModalOpen ? <ExpandLessIcon className='text-[#44546F]' /> : <ExpandMoreIcon className='text-[#44546F]' />}
      </button>
      <nav className='absolute top-[110%]'>
        <ContextModal isOpen={isModalOpen} onClose={toogleModal} width='max-content' inputStyles='flex gap-1 flex-col'>
          {/* Temporary hidden nav items */}
          {/* {customLink('/my-goals', Target, t('nav.myGoals'))} */}
          {/* {customLink('/tradings', TrendingUp, t('nav.tradings'))} */}
          {/* {customLink('/fundraising', Database, t('nav.fundraising'))} */}
          {/* {customLink('/automatic-savings', Save, t('nav.automaticSavings'))} */}
          {/* TODO uncomment aftre implementation on BE */}
          {title === 'services' ? (
            <>
              {customLink('/my-accounts', t('nav.myAccounts'), 'myAccounts')}
              {!!isLoansFeature && customLink('/loans', t('nav.loans'), 'loans')}
              {!!isExchangesFeature && customLink('/exchanges', t('nav.exchanges'), 'exchanges')}
              {!!isDepositsFeature && customLink('/deposits', t('nav.deposit'), 'deposit')}
              {!!isSavingFeature && customLink('/saving', t('nav.saving'), 'saving')}
              {!!isCardFeature && customLink('/cards', t('nav.cards'), 'cards')}
              {isCheckbookFeature && customLink('/checkbook', t('nav.checkbook'), 'checkbook')}
              {customLink('/tickets', t('nav.tickets'), 'tickets')}
            </>
          ) : (
            <>
              {customLink('/transactions', t('nav.transactions'), 'transactions')}
              {!!isStatementsFeature && customLink('/my-statements', t('nav.myStatements'), 'myStatements')}
              {customLink('/transactions-validation', t('nav.transactionsValidation'), 'transactionsValidation')}
              {customLink('/transactions-pending', t('nav.IbTransactions'), 'transactionPending')}
            </>
          )}
        </ContextModal>
      </nav>
    </div>
  );
};
